export default __webpack_public_path__ + "static/media/logo2.ee31c060.svg";